// src/components/FullScreenSpinner.tsx
import React, { useEffect, useState, useRef } from "react";
import "../css/fullscreenspinner.css";

const FullScreenSpinner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    // Activamos la clase "visible" para disparar el fade in
    setVisible(true);

    const svgElement = svgRef.current;
    if (!svgElement) return;

    const paths = svgElement.querySelectorAll("path");
    paths.forEach((path, index) => {
      const length = path.getTotalLength();
      // Configura el trazo para que se oculte inicialmente
      path.style.setProperty("--path-length", length.toString());
      path.style.strokeDasharray = length.toString();
      path.style.strokeDashoffset = length.toString();

      // Aplica un retraso escalonado para cada path
      const delay = index * 0.1;
      path.style.animation = `loopAnim 4s ease ${delay}s infinite`;
    });
  }, []);

  return (
    <div className={`full-screen-spinner ${visible ? "visible" : ""}`}>
      <svg
        ref={svgRef}
        className="full-screen-spinner__svg"
        version="1.1"
        id="full-screen-spinner__svg-id"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 300 300"
        xmlSpace="preserve"
      >
        <g className="full-screen-spinner__group">
          <path
            className="full-screen-spinner__path"
            d="M155.23,56.65c8.11-3.11,16.23-6.2,24.32-9.36c1.18-0.46,2.22-1.26,3.34-1.91c5.08,12.5,16.94,13.78,27.65,16.83
              c1.13,0.32,2.76-0.36,3.93-1c5.54-3.01,8.73-2.62,13.53,2.09c-1.17,0.19-2.2,0.35-4.09,0.66c3.08,5.02,5.91,9.62,8.54,13.91
              c-5.22-2.48-11.3-2.62-17.67-1.79c-4.23,0.55-7.61,1.3-8.41,5.64c-2.58-1.83-5.18-3.67-7.69-5.45c2.95-2.8,3-4.21-0.23-7.74
              c-6.34-6.96-14.27-9.88-23.59-9.1c-5.85,0.49-10.46,5.32-10.42,12.01c0.02,4.05,0.72,8.56,2.64,12.04
              c7.39,13.43,18.52,22.36,33.94,25.09c9.49,1.68,13.27-2.81,10.46-11.94c-0.3-0.98-0.56-1.97-0.62-3.1
              c6.5,11.18,17.19,17.78,27.02,25.38c5.23,4.04,9.79,8.95,14.76,13.56c0.29-0.84,0.67-1.97,1.15-3.37c1.36,2.07,2.39,4.22,3.96,5.84
              c1.05,1.09,2.87,1.44,4.35,2.12c0.61-1.51,1.74-3.03,1.73-4.53c-0.04-4.35-0.54-8.7-0.92-13.82c2.39,1.89,3.85,3.39,5.61,4.3
              c1.21,0.63,3.34,1.08,4.15,0.45c1.04-0.8,1.84-2.94,1.54-4.21c-0.75-3.23-2.18-6.3-3.43-9.66c5.95,3.96,10.57,9.15,14.66,14.87
              c0.67,0.94,1.05,2.12,1.84,2.92c8.39,8.67,8.07,21.21-0.77,29.41c-2.16,2.01-4.53,3.2-7.59,2.77c-2.63-0.37-4.71,0.7-7.13,1.85
              c-4.87,2.31-10.2,3.85-15.48,5.05c-3.26,0.74-7.92-2.74-8.27-6.15c-0.85-8.35-6.25-11.9-13.27-14.92
              c-13.49-5.79-27.28-8.81-41.95-6.89c-2.29,0.3-4.62,0.79-6.77,1.61c-3.6,1.37-5.81,4.16-5.56,8.07
              c0.81,13.17,1.91,26.26,9.65,37.73c9.91,14.7,14.93,31.34,17.46,48.6c2.19,14.96,8.98,27.25,18.72,38.33
              c5.11,5.82,10.91,10.66,17.48,14.9c4.68,3.02,8.11,7.96,11.63,12.26c-9.39-5.54-18.83-10.99-28.15-16.64
              c-9.73-5.9-17.76-13.62-23.79-23.3c-4.04-6.49-7.94-13.06-12.34-20.32c3.66,3.12,6.7,5.72,9.27,7.91
              c-2.4-7.02-4.13-14.8-7.66-21.66c-4.22-8.22-9.59-15.94-15.16-23.36c-6.5-8.67-14.24-16.42-20.56-25.21
              c-13.72-19.09-19.39-40.79-19.31-64.17c0.02-6.32-0.67-12.64-1.01-18.5c4.71,4.85,4.14,12.14,5.43,18.81c0.29,0,0.58,0,0.87,0
              c0-8.58,0-17.15,0-26.09c-7.81-0.14-15.82,1.63-23.25,6.02c-17.67,10.44-35.34,20.88-53.09,31.19c-3.9,2.26-8.13,3.96-12.2,5.92
              l0.09-0.09c-4.49,0.59-8.99,1.77-13.45,1.65c-8.66-0.22-12.92-6.53-10.65-14.84c2.2-8.02,5.61-12.13,15.19-17.99
              c-1.32-0.34-2.23-0.76-3.16-0.79c-10.81-0.41-15.25-5.85-13.28-16.35c1.75-9.3,9.17-16.54,18.58-17.98
              c4.19-0.64,8.22-1.54,11.11-5.09c-1.14,3.96-4.02,5.97-7.68,7.16c-7.39,2.41-12.97,10.62-12.49,18.38
              c0.16,2.61,1.14,4.69,3.35,5.58c0.64-3.18,1.27-6.32,1.91-9.46c0.27,0.06,0.54,0.11,0.82,0.17c-0.14,2.05-0.5,4.12-0.37,6.15
              c0.22,3.29,1.97,4.53,4.89,3.16c3.24-1.51,6.61-3.19,9.17-5.6c5.51-5.2,10.54-10.9,15.74-16.42c0.61-0.64,1.03-1.46,1.75-2.49
              c-1.42-0.07-2.43-0.09-3.44-0.17c-4.99-0.42-7.87-3.13-8.6-8.07c-1.69-11.46,4.36-21.09,14.39-22.91c3.36-0.61,6.14,0.29,7.98,2.59
              c-7.58-1.89-10.2,3.47-12.87,8.75c5.93,4.36,20.62,2.17,25.26-4.21c-3.26-1.59-6.6-2.89-9.57-4.77c-3.27-2.06-4.54-5.42-4.72-9.91
              c3.77,10.04,6.5,11.53,18.93,10.45c-0.85-3-1.76-5.84-2.45-8.73c-1-4.18,1.68-8.33,5.46-9.04c-0.52,1.88-1.56,3.89-1.49,5.85
              c0.06,1.83,1.3,3.63,2.66,5.43c2.21-8.29,3.44-16.84,13.85-18.57c0-4.08,0-8.1,0-12.39c4.56,10.82,14.04,14.93,24.37,18.17
              c0.11-6.89,5.11-14.31,11.81-15.76c5.3-1.15,10.74-3.91,16.37-1.6c2.48,1.02,4.66,2.75,7.4,4.4c-10.13,4.5-17.5,10.52-19.55,15.43
              c6.78,3.24,13.54,6.47,20.31,9.7c-0.07,0.4-0.13,0.79-0.2,1.19c-4.28,1.88-8.57,3.75-13.07,5.72c-4.11-6.71-10.88-9.88-17.63-13.11
              c-4.1-1.97-8.13-4.08-12.21-6.08c-4.5-2.21-8.65,0.48-8.49,5.46c0.34,10.55,6.01,16.1,17.58,16.85c4.63,0.3,9.3,0.05,13.88,0.05
              c-1.67,0.73-3.59,1.57-5.51,2.41c0.05,0.18,0.09,0.36,0.14,0.54c1.71-0.57,3.46-1.03,5.12-1.73c7.84-3.31,15.53-7,23.5-9.96
              c11.32-4.2,23.05-5.52,35.15-4.16c4,0.45,8.13-0.44,12.21-0.57c3.38-0.11,6.76-0.02,10.08-0.54c-12.3,2.33-24.65,4.42-36.88,7.09
              c-8.15,1.78-15.31,5.99-22.57,10.08c-7.87,4.44-16.39,7.72-24.63,11.5c-1.1,0.51-2.19,1.03-3.28,1.54c-0.8,0.03-1.63-0.07-2.4,0.11
              c-5.93,1.35-11.84,2.87-17.86,0.36c-0.38-0.16-1.08,0.05-1.43,0.33c-11.34,9.24-21.15,19.68-26.18,33.78
              c-0.66,1.86-1.37,3.33-3.6,3.08c0-4.83,0.14-9.47-0.09-14.1c-0.06-1.18-1.13-3.1-2.01-3.27c-1.15-0.22-3.16,0.59-3.79,1.59
              c-3.07,4.88-6.44,9.74-8.49,15.07c-2.27,5.92-2.68,12.76-11.16,13.78c1.55,0.01,2.72-0.36,3.81-0.88c6-2.86,12-5.7,17.96-8.65
              c13.62-6.75,27.27-13.35,42.9-14.01c0.79-0.03,1.95-1.49,2.19-2.47c1.83-7.54,3.48-15.13,5.26-23.02
              C151.63,57.96,153.43,57.31,155.23,56.65z"
          />
          <path
            className="full-screen-spinner__path"
            d="M54.49,130.62c1.74-0.46,3.61-0.64,5.19-1.42c7.1-3.53,14.11-7.22,21.16-10.86c1.01-0.52,2.03-1.04,2.98-1.53
              c0.3,0.28,0.58,0.42,0.59,0.57c0.98,14.63,2.23,29.25,2.82,43.9c0.53,13.26,0.82,26.57,0.31,39.82
              c-0.58,15.01,3.1,28.53,12.53,40.08c3.97,4.87,9.45,8.53,14.37,12.6c1.68,1.39,3.71,2.35,5.44,3.96
              c-6.25-1.35-12.48-2.77-18.75-4.02c-1.93-0.38-3.95-0.47-5.92-0.41c-7.28,0.23-12.15,4.22-13.54,11.31
              c-1.95,10-0.39,18.81,9.12,25.13c-1.28-0.09-2.59-0.06-3.85-0.28c-16.74-2.89-32.8-8.1-48.58-14.27c-2.04-0.8-2.46-1.93-2.42-3.91
              c0.12-5.81,0.04-11.61,0.04-17.7c-5.73,0.36-12.15-0.14-14.68-6.87c-2.06-5.48-0.94-11.16,3.23-16.42
              c0.21,1.41,0.34,2.34,0.48,3.26c-0.85-4.77,1.56-8.44,4.04-12.03c0.71-1.02,1.58-2.61,3.25-0.98c5.82,7.65,14.05,6.22,21.99,5.82
              c-3.76-0.3-7.72,0.17-11.26-0.84c-3.65-1.04-6.89-3.52-10.31-5.36c-0.16-1.25-0.16-2.55-0.52-3.74c-0.91-3.01,0.02-5.54,1.92-7.77
              c2.87-3.37,5.83-6.67,8.79-9.96c1.65-1.84,1.8-3.27-0.55-4.76c-7.18-4.55-7.59-5.82-5.07-14.17c-5.55-1.5-6.81-5.32-6.09-10.68
              c0.33-2.46-0.74-5.11-1.25-8.09c-0.69,0.46-1.57,1.05-2.43,1.64c-8.82,6.08-20.3,0.82-20.83-9.83c-0.22-4.44,0.32-9.07,1.4-13.39
              c1.23-4.92,4.24-7.63,8.3-9.54c-0.72,3.01-1.95,6.28-2.21,9.61c-0.66,8.43,3.05,12.57,11.51,12.67c8.3,0.1,15.61-2.63,21.03-9.22
              c1.31-1.59,2.63-3.47,3.04-5.41c0.67-3.14,1.6-5.77,4.81-7.04C54.57,130.53,54.49,130.62,54.49,130.62z M56.13,242.22
              c0-0.46,0-0.91,0-1.37c-3.5,0-7.02-0.2-10.51,0.04c-6.5,0.46-13.05,1.54-18.63-3.36c2.59,3.66,6.28,4.67,10.39,4.68
              C43.63,242.23,49.88,242.22,56.13,242.22z"
          />
          <path
            className="full-screen-spinner__path"
            d="M220.29,292.35c-12.41-4.3-24.89-8.43-37.22-12.94c-10.62-3.88-21.51-7.55-30.32-14.87
              c-15.48-12.84-29.7-27.01-41.22-43.58c-9.7-13.94-13.2-29.87-13.79-46.58c-0.44-12.34-0.77-24.69-1.42-37.02
              c-0.29-5.55-1.26-11.06-1.93-16.59c0.34-0.05,0.67-0.11,1.01-0.16c1.71,10.81,3.49,21.62,5.09,32.45c1.23,8.29,2.06,16.64,3.4,24.9
              c2.12,13.1,7.98,24.58,16.65,34.49c11.36,12.99,22.97,25.77,34.66,38.48c12.13,13.19,27.33,22.03,43.33,29.65
              c7.45,3.55,14.88,7.11,22.32,10.67C220.66,291.61,220.48,291.98,220.29,292.35z"
          />
          <path
            className="full-screen-spinner__path"
            d="M97,36.88c-4.23,0.09-7.6-1.37-9.61-5.1c-2.61-4.85-1.75-9.43,1.5-13.66c1.87-2.42,3.66-5.17,7.96-3.89
              c-4.77,1.53-7.42,4.34-7.59,9.14C89.06,29.45,90.91,34.32,97,36.88z"
          />
        </g>
      </svg>
    </div>
  );
};

export default FullScreenSpinner;
